import * as basic from './basic';
import * as math from './math';
import * as text from './text';
import * as list from './list';

const is = {
  ...basic,
  ...math,
  ...text,
  ...list,
};

export default is;
